<template>
  <select-component
    v-if="gender"
    :options-list="gender.values"
    :selectedValue="selectedGender"
    :prop-for-name="$options.displayFieldName"
    :prop-for-value="$options.compareFieldName"
    @update:selectedValue="updateSelectedGender"
    :case-sensitive="false"
    class="d-flex cw-gender-filter align-items-center gap-1 position-relative"
  >
    <template v-slot:label>
      <div class="cw-gender-filter__title p-2 d-flex align-items-center">
        <span>{{ $t('Gender') }}</span>
      </div>
    </template>
    <template v-slot:default="{option}">
      <div class="d-flex justify-content-between w-100 px-2">
        <span>{{ $t(genderTitle(option[$options.displayFieldName])) }}</span>
      </div>
    </template>
  </select-component>
</template>

<script>
import SelectComponent from '@/components/base-components/customSelect/SelectComponent.vue';
import {mapState} from 'vuex';
import {GET_PARTICIPANTS_PROPS} from '@/store/actionTypes';
import {mapCacheActions} from 'vuex-cache';
import {LONG_GENDERS_NAMES, PARTICIPANT_PROP_NAMES, URL_QUERIES} from '@/const';
import {updateRouteQuery} from '@/utils/helpers';

export default {
  name: 'GenderFilter',
  components: {SelectComponent},
  compareFieldName: 'value',
  displayFieldName: 'value',
  data() {
    return {
      selectedGender: this.$route.query[URL_QUERIES.gender] ?? '',
    };
  },
  watch: {
    async $route() {
      await this.$nextTick();
      this.selectedGender = this.$route.query[URL_QUERIES.gender];
    },
    genderData() {
      const gender = this.genderData &&
        {
          [this.gender.id]: [this.genderData?.id],
        };
      updateRouteQuery(
          this.$route,
          this.$router,
          URL_QUERIES.gender,
          this.genderData?.[this.$options.compareFieldName],
      );
      this.$emit('update:gender', gender);
    },
  },
  computed: {
    ...mapState({
      props: (state) => state.participant.participantsProps,
    }),
    gender() {
      return this.props.find(({name}) => name.toLowerCase() === PARTICIPANT_PROP_NAMES.GENDER);
    },
    genderData() {
      return this.gender?.values?.find(({[this.$options.compareFieldName]: value}) => {
        return String(value).toLowerCase() === String(this.selectedGender).toLowerCase();
      });
    },
  },
  methods: {
    ...mapCacheActions({
      getProps: GET_PARTICIPANTS_PROPS,
    }),
    updateSelectedGender(genderValue) {
      this.selectedGender = genderValue?.[0]?.[this.$options.compareFieldName];
    },
    clear() {
      this.selectedGender = null;
    },
    genderTitle(gender) {
      return LONG_GENDERS_NAMES[gender?.toLowerCase?.()] || gender;
    },
  },
  mounted() {
    this.getProps();
    this.$emit('interface', {
      clear: this.clear,
    });
  },
};
</script>

<style scoped lang="scss">
.cw-gender-filter {
  --border-color: var(--settings-footer-background-20);
  border: 1px solid var(--settings-footer-background-50);
  border-radius: .3rem;
}

.cw-gender-filter__title {
  background: var(--settings-body-text-color-50);
  height: 100%;
}
</style>
